
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { supabase } from './integrations/supabase/client'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import AuthPage from './pages/AuthPage.tsx'
import NotFoundPage from './pages/NotFoundPage.tsx'
import { PostHogProvider } from './components/providers/PostHogProvider.tsx'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

const router = createBrowserRouter([
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "*",
    element: <App />,
    errorElement: <NotFoundPage />,
  },
]);

createRoot(document.getElementById("root")!).render(
  <PostHogProvider>
    <QueryClientProvider client={queryClient}>
      <SessionContextProvider supabaseClient={supabase}>
        <RouterProvider router={router} />
      </SessionContextProvider>
    </QueryClientProvider>
  </PostHogProvider>
);
